import React from 'react';
import { Link } from 'react-router-dom';

export default function SmartiLabDisabledPage() {
  return (
    <div className="lab-disabled-page">
      <div className="lab-disabled-card">
        <span className="lab-badge">Disattivato</span>
        <h1>Smarti Lab non è attivo</h1>
        <p>Questo modulo sperimentale è disattivato in questa installazione.</p>
        <Link to="/dashboard" className="lab-button">Torna al selettore dashboard</Link>
      </div>
    </div>
  );
}
